import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "VI. Allergies アレルギー", -1)
const _hoisted_3 = { class: "grid grid-cols-1 mb-10 lg:grid-cols-12 gap-x-8 gap-y-6" }
const _hoisted_4 = { class: "col-span-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Do you have any allergies? アレルギーはありますか：", -1)
const _hoisted_6 = { class: "grid grid-cols-1 space-y-2 lg:grid-cols-12" }
const _hoisted_7 = { class: "col-span-full mt-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-gray-700" }, " Check if you are frequently experiencing any of the following / 次のいずれかの処置をうけたことがある場合には、下記のボックスにチェックを入れてください: ", -1)
const _hoisted_9 = { class: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-3" }
const _hoisted_10 = { class: "space-y-3" }
const _hoisted_11 = { class: "space-y-3" }
const _hoisted_12 = { class: "space-y-2" }
const _hoisted_13 = { class: "mt-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-700 mb-2" }, " Additional Notes (Please specify the food/medicine/other allergies): 追加の注意事項(食物・薬物・その他のアレルギーについて記載してください) ", -1)
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "text-[10px] mt-1 text-red-600"
}

import TextInput from '@/components/inputs/TextInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import { ref, watch, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AllergiesInformation',
  props: {
    form: {
        type: Object,
        required: true
    },
    errors: {
        type: Array,
        required: true
    },
    disableInputs: {
        type: Boolean,
        default: false
    }
},
  setup(__props) {

const props = __props

const item = ref(props.form)

const selectedVal = computed(() => item.value);

// watch(
//     () => item.value.has_allergies,
//     (val: string) => {
//         if (val === 'no') {
//             // Reset all allergy symptoms
//             item.value.itchy_skin = false;
//             item.value.rash_or_hives = false;
//             item.value.swelling = false;
//             item.value.itchy_eyes = false;
//             item.value.watery_eyes = false;
//             item.value.fatigue = false;
//             item.value.coughing = false;
//             item.value.shortness_of_breath = false;
//             item.value.sneezing = false;
//             item.value.runny_or_stuffy_nose = false;
//             item.value.others = false;
//             item.value.others_specify = null;
//             item.value.additional_notes = null;
//         }
//     }
// );

watch(
    () => item.value.others,
    (val: boolean) => {
        if (!val) {
            item.value.others_specify = null;
        }
    }
);

const leftColumnOptions = [
    { key: 'itchy_skin', label: 'Itchy skin' },
    { key: 'rash_or_hives', label: 'Rash or hives' },
    { key: 'swelling', label: 'Swelling' },
    { key: 'itchy_eyes', label: 'Itchy eyes' },
    { key: 'watery_eyes', label: 'Watery eyes' },
    { key: 'fatigue', label: 'Fatigue' },
];

const rightColumnOptions = [
    { key: 'coughing', label: 'Coughing' },
    { key: 'shortness_of_breath', label: 'Shortness of breath' },
    { key: 'sneezing', label: 'Sneezing' },
    { key: 'runny_or_stuffy_nose', label: 'Runny or stuffy nose' },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(leftColumnOptions, (option) => {
                  return _createVNode(CheckboxInput, {
                    key: option.key,
                    modelValue: item.value[option.key],
                    "onUpdate:modelValue": ($event: any) => ((item.value[option.key]) = $event),
                    disabled: __props.disableInputs,
                    label: option.label,
                    rounded: false,
                    "is-checked": item.value[option.key]
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "label", "is-checked"])
                }), 64))
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rightColumnOptions, (option) => {
                  return _createVNode(CheckboxInput, {
                    key: option.key,
                    modelValue: item.value[option.key],
                    "onUpdate:modelValue": ($event: any) => ((item.value[option.key]) = $event),
                    disabled: __props.disableInputs,
                    label: option.label,
                    rounded: false,
                    "is-checked": item.value[option.key]
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "label", "is-checked"])
                }), 64)),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(CheckboxInput, {
                    modelValue: item.value.others,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.others) = $event)),
                    disabled: __props.disableInputs,
                    label: "Others/その他",
                    rounded: false,
                    "is-checked": item.value.others
                  }, null, 8, ["modelValue", "disabled", "is-checked"]),
                  (item.value.others)
                    ? (_openBlock(), _createBlock(TextInput, {
                        key: 0,
                        id: "others_specify",
                        type: "text",
                        placeholder: "Type here",
                        disabled: __props.disableInputs,
                        modelValue: item.value.others_specify,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.others_specify) = $event)),
                        error: __props.errors['allergies.others_specify'] ? __props.errors['allergies.others_specify'][0] : '',
                        class: "ml-7 mt-2"
                      }, null, 8, ["disabled", "modelValue", "error"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _withDirectives(_createElementVNode("textarea", {
                disabled: __props.disableInputs,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.additional_notes) = $event)),
                rows: "4",
                class: _normalizeClass(["w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent", {
                                    'bg-gray-100': __props.disableInputs,
                                    'border-red-500': __props.errors['allergies.additional_notes']
                                }])
              }, null, 10, _hoisted_15), [
                [_vModelText, item.value.additional_notes]
              ]),
              (__props.errors['allergies.additional_notes'])
                ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(__props.errors['allergies.additional_notes'][0]), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})